// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2oN4I","paymentContainer":"PaymentPage_paymentContainer__2XLa5"};